import { RECORDS_PER_PAGE, TOAST_VARIANT } from "@root/constants";
import { useState } from "react";
import { useDispatch } from "react-redux";
import {
  FETCH_RESOURCES,
  DELETE_RESOURCES,
  ADD_RESOURCES,
} from "@root/store/action-types";
import {
  doAddResources,
  getResources,
  deleteResource,
} from "@root/store/thunks";
import { useNotification } from "./useNotification";
import { t } from "i18next";

function useResources() {
  const dispatch = useDispatch();
  const [resourcesLoading, setResourcesloading] = useState(false);
  const { showNotification } = useNotification();
  const [addResourcesLoading, setAddResourceLoading] = useState(false);
  const [deleteResourcesLoading, setDeleteResourcesLoading] = useState(false);

  const [resourcesData, setResourcesData] = useState<any>(null);

  const [pageNo, setPageNo] = useState(1);
  const [pageCount, setPageCount] = useState(0);
  const pageSize = RECORDS_PER_PAGE;

  const onSuccess = (data: any, identifier: any, callaback: any) => {
    if (identifier === FETCH_RESOURCES) {
      setPageCount(data?.count);
      setResourcesData(data?.rows);
      setResourcesloading(false);
    }
    if (identifier === DELETE_RESOURCES) {
      setDeleteResourcesLoading(false);
    }
    if (identifier === ADD_RESOURCES) {
      setAddResourceLoading(false);
    }
  };

  const onError = (error: any, identifier: any) => {
    if (identifier === FETCH_RESOURCES) {
      setResourcesloading(false);
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message: t("resourcesTab.fetchError"),
      });
    }
    if (identifier === DELETE_RESOURCES) {
      setDeleteResourcesLoading(false);
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message: t("resourcesTab.deleteError"),
      });
    }
    if (identifier === ADD_RESOURCES) {
      setAddResourceLoading(false);
      showNotification({
        type: TOAST_VARIANT.ERROR,
        message: t("resourcesTab.addError"),
      });
    }
  };

  const addResource = (payload: any) => {
    setAddResourceLoading(true);
    dispatch(
      doAddResources({
        payload,
        onSuccess: (data: any, identifier: any) => {
          setAddResourceLoading(false);
          // Refresh the resources list after adding
          showNotification({
            type: TOAST_VARIANT.SUCCESS,
            message: t("resourcesTab.addSuccess"),
          });
          fetchResources({
            offset: (pageNo - 1) * pageSize,
            limit: pageSize,
          });
        },
        onError,
      })
    );
  };

  const fetchResources = (payload: any) => {
    setResourcesloading(true);
    dispatch(
      getResources({
        payload,
        onSuccess,
        onError,
      })
    );
  };

  const removeResource = (id: number, onSuccessCallback?: () => void) => {
    setDeleteResourcesLoading(true);
    dispatch(
      deleteResource({
        id,
        onSuccess: (data: any, identifier: any) => {
          setDeleteResourcesLoading(false);
          showNotification({
            type: TOAST_VARIANT.SUCCESS,
            message: t("resourcesTab.deleteSuccess"),
          });
          fetchResources({
            offset: (pageNo - 1) * pageSize,
            limit: pageSize,
          });
          if (onSuccessCallback) onSuccessCallback();
        },
        onError,
      })
    );
  };

  return {
    resourcesLoading,
    addResourcesLoading,
    deleteResourcesLoading,
    resourcesData,
    pageNo,
    setPageNo,
    pageCount,
    setPageCount,
    removeResource,
    fetchResources,
    addResource,
    pageSize,
  };
}
export default useResources;
